const countdown = document.querySelector(".countdown"),
  botonSello = document.getElementById("botonSello"),
  sobre = document.querySelector(".sobre"),
  portadaFoto = document.querySelector(".portada__foto"),
  formulario = document.getElementById("formulario"),
  boton = document.getElementById("boton"),
  radioButtons = document.querySelectorAll('input[name="respuesta"]'),
  preguntaConfirmacion = document.getElementById("preguntaConfirmacion"),
  aceptaConfirmacion = document.getElementById("aceptaConfirmacion"),
  rechazaConfirmacion = document.getElementById("rechazaConfirmacion"),
  asistentes = document.getElementById("asistentes"),
  formText = document.querySelector(".form-text"),
  token = document.getElementById("token").value,
  numeroMesa = document.getElementById("numero_mesa").value,
  paquete = document.getElementById("paquete").value,
  // desbloquear = document.getElementById('desbloquear'),
  documento = document.querySelector(".documento"),
  // bienvenida = document.querySelector('.bienvenida '),
  icon = document.querySelector(".play"),
  audio = document.getElementById("audio"),
  btnPlay = document.getElementById("btn-play"),
  agendar1 = document.querySelector(".agendar1");
// agendar2 = document.querySelector('.agendar2');

if (asistentes) {
  const valueAsistentes = asistentes.options[asistentes.selectedIndex];
}

// let ubicacionPrincipal = window.pageYOffset;

document.addEventListener("DOMContentLoaded", function () {
  inicarApp();
});

function inicarApp() {
  bloquearScroll();
  abrirSobre();
  if (asistentes) {
    desplegarCantidadPersonas();
  }
  validarFormulario();
  // aparecerElementos();
  botonCalendario1();
  // botonCalendario2();
}

function bloquearScroll() {
  if (documento) {
    documento.classList.add("bloqueaScroll");
  }
}

if (btnPlay) {
  btnPlay.addEventListener("click", () => togglePlay());
}

function togglePlay() {
  if (!audio) {
    return;
  }

  if (audio.paused) {
    audio.play().catch(() => {});
    if (icon) {
      icon.setAttribute("icon", "mdi:pause");
    }
  } else {
    audio.pause();
    if (icon) {
      icon.setAttribute("icon", "mdi:play");
    }
  }
}

function createSlide(origin) {
  return {
    distance: "100%",
    origin: origin,
    opacity: null,
    delay: 700,
  };
}

const revealBase = {
  distance: "0px",
  viewFactor: 0.4,
  viewOffset: {
    top: 100, // Valor negativo = espera un poco más antes de revelar
    bottom: 0,
  },
};

function revealWithClass(selector, animationClass, duration = "0.5s") {
  ScrollReveal().reveal(selector, {
    ...revealBase,
    beforeReveal(el) {
      el.style.animationDuration = duration;
      el.classList.remove(animationClass);
      void el.offsetWidth;
      el.classList.add(animationClass);
    },
  });
}

var slideUp = createSlide("bottom");
var slideDown = createSlide("top");
var slideRight = createSlide("right");
var slideLeft = createSlide("left");

function abrirSobre() {
  if (!botonSello) {
    return;
  }

  botonSello.addEventListener("click", function () {
    sobre.classList.add("abierto");
    if (portadaFoto) {
      portadaFoto.classList.add("portada__abierto");
    }
    aparecerElementos();
    iniciarInvitacion();
    setTimeout(() => {
      documento.classList.remove("bloqueaScroll");
    }, 100);
  });
}

function iniciarInvitacion() {
  if (audio) {
    audio.currentTime = 0;
    audio.play().catch(() => {});
  }

  if (icon) {
    icon.setAttribute("icon", "mdi:pause");
  }

  if (portadaFoto) {
    portadaFoto.currentTime = 0;
    portadaFoto.play().catch(() => {});
  }
}

function aparecerElementos() {
  ScrollReveal().reveal(".portada__titulo", { delay: 700, duration: 2000 });
  ScrollReveal().reveal(".portada__nombre", { delay: 800, duration: 2000 });
  ScrollReveal().reveal(".portada__fecha", { delay: 700, duration: 2000 });
  ScrollReveal().reveal(".portada__leyenda", { delay: 900, duration: 2000 });
  revealWithClass(".parte1", "slide-top", "0.3s");
  revealWithClass(".parte2", "slide-top", "0.6s");
  revealWithClass(".parte3", "slide-top", "0.9s");
  revealWithClass(".contenedor-padres h2", "slide-left");
  revealWithClass(".contenedor-padres button", "slide-left");
  revealWithClass(".ceremonia", "slide-left");
  revealWithClass(".recepcion", "slide-left");
  revealWithClass(".ubicaciones__contenedor__item h2", "slide-right");
  revealWithClass(".ubicaciones__contenedor__item button", "slide-right");
  revealWithClass(".agradecimiento1__imagen", "slide-bck-center");
  revealWithClass(".quote-block", "slide-left");
  revealWithClass(".itinerario__flex__imagen", "slide-bck-center");
  revealWithClass(".itinerario__flex__texto", "slide-bck-center");
  revealWithClass(".galeria__grid__item", "slide-top");
  revealWithClass(".regalos__contenedor h1", "slide-left");
  revealWithClass(".regalos__imagen", "slide-top");
  revealWithClass(".regalos__contenedor__item button", "slide-top");
  revealWithClass(".vestimenta__imagenes", "slide-bck-center");
  // revealWithClass(".confirmacion__contenedor img", "slide-bck-center");
}

simplyCountdown(countdown, {
  year: 2030, // required
  month: 8, // required
  day: 2, // required
  hours: 14, // Default is 0 [0-23] integer
  minutes: 0, // Default is 0 [0-59] integer
  seconds: 0, // Default is 0 [0-59] integer
  words: {
    //words displayed into the countdown
    days: { singular: "Día", plural: "Días" },
    hours: { singular: "Hora", plural: "Horas" },
    minutes: { singular: "Minuto", plural: "Minutos" },
    seconds: { singular: "Segundo", plural: "Segundos" },
  },
  plural: true, //use plurals
  inline: false, //set to true to get an inline basic countdown like : 24 days, 4 hours, 2 minutes, 5 seconds
  inlineClass: "simply-countdown-inline", //inline css span class in case of inline = true
  // in case of inline set to false
  enableUtc: false,
  onEnd: function () {
    // your code
    return;
  },
  refresh: 1000, //default refresh every 1s
  sectionClass: "simply-section", //section css class
  amountClass: "simply-amount", // amount css class
  wordClass: "simply-word", // word css class
  zeroPad: false,
  countUp: false, // enable count up if set to true
});

function desplegarCantidadPersonas() {
  const si = document.getElementById("si");
  const no = document.getElementById("no");
  const select = document.querySelector(".select");

  si.addEventListener("click", function () {
    if (select.classList.contains("d-none")) {
      select.classList.remove("d-none");
    }
  });

  no.addEventListener("click", function () {
    select.classList.add("d-none");
  });
}

function validarFormulario() {
  for (const radioButton of radioButtons) {
    radioButton.addEventListener("click", function () {
      if (radioButton.checked) {
        boton.removeAttribute("disabled");
      }
    });
  }

  formulario.addEventListener("submit", function (e) {
    e.preventDefault();

    var datos = new FormData(formulario);
    fetch("post.php", {
      method: "POST",
      body: datos,
    })
      .then((respuesta) => respuesta.json())
      .then((data) => {
        if (data === "error") {
          Swal.fire({
            title: '<span class="alerta">Error<span>',
            text: "Lo sentimos tus datos no se enviaron correctamente, trata nuevamente",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          return;
        }

        Swal.fire({
          title: '<span class="alerta">¡Gracias!<span>',
          text: "Tus datos han sido enviados correctamente",
          icon: "success",
          confirmButtonText: "Aceptar",
        });

        const cantidad = parseInt(data.asistentes, 10);

        const renderTextoPersonas = (cantidad) => {
          const texto = cantidad === 1 ? "PERSONA" : "PERSONAS";
          return texto
            .split("")
            .map((letra) => `<span class="char">${letra}</span>`)
            .join("");
        };

        const renderTicket = (data) => `
          <div class="ticket-wrapper">
            <div class="ticket">
              <div class="ticket-edge-top-left"></div>
              <div class="ticket-edge-top-right"></div>
              <div class="ticket-edge-bottom-left"></div>
              <div class="ticket-edge-bottom-right"></div>
              <div class="ticket-punches"></div>
              <div class="ticket-punches-right"></div>

              <div class="ticket-inner">
                <div class="ticket-headline">
                  <span>${cantidad}</span>
                </div>

                <div class="ticket-star">
                  <div class="fa fa-star-o"></div>
                </div>

                <div class="ticket-admit">
                  ${renderTextoPersonas(cantidad)}
                </div>

                <div class="ticket-numbers">${data.invitado_id}</div>
                <div class="ticket-numbers second">${data.invitado_id}</div>
              </div>
            </div>
          </div>
        `;
        const renderMesa = (numeroMesa) =>
          numeroMesa != 0
            ? `<p>Tu mesa es la <span class="texto"> N° ${numeroMesa} </span></p>`
            : "";

        if (radioButtons[0].checked) {
          preguntaConfirmacion.classList.add("d-none");

          const contenidoQR =
            paquete == 3
              ? `
          <p class="fs-5">Código de Confirmación QR</p>
          <div class="d-flex justify-content-center align-items-center">
            <div class="contenedor-qr">
              <img class="qr" src="qr/${token}.png" alt="qr">
            </div>
          </div>
        `
              : "";

          formText.innerHTML = `
      <div class="contenido-form" id="aceptaConfirmacion">
        <h2>¡Agradecemos mucho tu confirmación!</h2>
        <h3>${data.invitado}</h3>
        <p class="mt-4 mb-0">Tu invitación es para:</p>

        <div class="w-100 d-flex justify-content-center">
          ${renderTicket(data)}
        </div>

        ${renderMesa(numeroMesa)}
        ${contenidoQR}
      </div>
    `;
        } else if (radioButtons[1].checked) {
          preguntaConfirmacion.classList.add("d-none");
          formText.innerHTML = `
      <div class="contenido-form" id="rechazaConfirmacion">
        <h2>Lamentamos que no puedas asistir, pero agradecemos tu confirmación</h2>
      </div>
    `;
        }
      });
  });
}

function botonCalendario1() {
  const config = {
    name: "Boda de Maribel y Carlos ",
    description: "",
    startDate: "2030-8-2",
    endDate: "2030-8-2",
    options: ["Google", "Apple"],
    timeZone: "America/Tijuana",
    startTime: "18:00",
    endTime: "18:30",
    trigger: "click",
    iCalFileName: "Reminder-Event",
  };

  agendar1.addEventListener("click", () => atcb_action(config, agendar1));
}

// function botonCalendario2() {
//   const config = {
//     name: 'XV Años Agustina Aguilar',
//     description: '',
//     startDate: '2030-8-2',
//     endDate: '2024-9-28',
//     options: ['Google', 'Apple'],
//     timeZone: 'America/Tijuana',
//     startTime: '11:00',
//     endTime: '11:30',
//     trigger: 'click',
//     iCalFileName: 'Reminder-Event',
//   };

//   agendar2.addEventListener('click', () => atcb_action(config, agendar2));
// }
